import { actionTypes } from '../../types';

// Action creator for generating OTP request
export const manualContentList = (payload) => ({
    type: actionTypes.MANUAL_CONTENT_LIST_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const manualContentListSuccess = (payload) => ({
    type: actionTypes.MANUAL_CONTENT_LIST_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const manualContentListFailure = (payload) => ({
    type: actionTypes.MANUAL_CONTENT_LIST_FAILURE,
    payload,
});

export const manualContentListReset = () => ({
    type: actionTypes.MANUAL_CONTENT_LIST_RESET,
});

// Action creator for resetting all OTP generation reducer
export const manualContentListResetAll = () => ({
    type: actionTypes.MANUAL_CONTENT_LIST_RESET_ALL,
});
